/* LicensedTime header search overlay: team matches, type-ahead products (gate-filtered section), recent searches. */
(() => {
  'use strict';
  /* Storefront search is always limited to live products (tag lt-live). Shopify ORs plain words, so the query is built from
     fielded terms, which AND together: a team name/alias/code -> that team's tag; otherwise every word must be in the title. */
  const norm = (s) => String(s || '').trim().toLowerCase();
  const buildQuery = (q, type) => {
    const words = String(q || '').trim().split(/\s+/).filter(Boolean);
    let parts;
    const LT = window.LT;
    let exact = null;
    if (LT && LT.teams) {
      exact = LT.teams.find((t) => [t.n, t.s, t.m, t.c].concat(t.a || []).some((v) => v && norm(v) === norm(q))) || null;
      if (!exact && norm(q).length >= 3) {
        const found = LT.matches(q);
        if (found.length === 1) exact = found[0]; // e.g. "bama" is only Alabama
      }
    }
    if (exact && exact.lg && exact.c) parts = [`tag:${exact.lg}-${exact.c}`];
    else parts = words.map((w) => `title:${w.replace(/[^\p{L}\p{N}'-]/gu, '')}`).filter((w) => w !== 'title:');
    parts.push('tag:lt-live');
    if (type && type !== 'all') parts.push(`product_type:${type}`);
    return parts.join(' ');
  };
  const searchUrl = (q, type) => `/search?type=product&q=${encodeURIComponent(buildQuery(q, type))}&lt_q=${encodeURIComponent(String(q || '').trim())}`;
  window.LTSearch = { buildQuery, url: searchUrl };

  const dlg = document.querySelector('[data-lt-sbox]');
  const openBtn = document.querySelector('[data-lt-search-open]');
  if (!dlg || !openBtn) return;
  /* (the overlay's recent searches and "See all" links use searchUrl above) */
  const input = dlg.querySelector('[data-lt-sbox-input]');
  const body = dlg.querySelector('[data-lt-sbox-body]');
  const KEY = 'lt_recent_searches';
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const hex = (h) => (typeof h === 'string' && /^#[0-9a-f]{3,8}$/i.test(h) ? h : '#C9CCD0');

  const recents = () => {
    try {
      const v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.slice(0, 5) : [];
    } catch (e) {
      return [];
    }
  };
  const saveRecent = (q) => {
    q = q.trim();
    if (!q) return;
    try {
      const list = [q].concat(recents().filter((r) => r.toLowerCase() !== q.toLowerCase())).slice(0, 5);
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  };
  const clearRecents = () => {
    try {
      localStorage.removeItem(KEY);
    } catch (e) {}
  };

  const teamRow = (t) => {
    const dot = `<span class="lt-dot lt-dot--lg" style="background:${hex(t.p)}" aria-hidden="true"></span>`;
    const sub = `${esc(t.lg)}${t.cf ? ' · ' + esc(t.cf) : ''}`;
    if (t.live && t.u) {
      return `<a class="lt-sbox__team" href="${esc(t.u)}" data-lt-sbox-team="${esc(t.h)}">${dot}<span class="lt-sbox__tmain"><span class="lt-sbox__tname">${esc(t.n)}</span><span class="lt-sbox__tsub">${sub}</span></span><span class="lt-sbox__tgo">Shop team</span></a>`;
    }
    return `<div class="lt-sbox__team is-soon">${dot}<span class="lt-sbox__tmain"><span class="lt-sbox__tname">${esc(t.n)}</span><span class="lt-sbox__tsub">${sub}</span></span><span class="lt-sbox__tgo">Coming soon</span></div>`;
  };

  const idle = () => {
    const r = recents();
    const my = window.LT && window.LT.getMyTeam && window.LT.getMyTeam();
    let html = '';
    if (r.length) {
      html += `<div class="lt-sbox__label">Recent searches <button type="button" class="lt-sbox__clear" data-lt-sbox-clear>Clear</button></div><div class="lt-sbox__recent">${r
        .map((q) => `<a href="${esc(searchUrl(q))}">${esc(q)}</a>`)
        .join('')}</div>`;
    }
    if (my && my.live && my.u) {
      html += `<div class="lt-sbox__label">Your team</div>${teamRow(my)}`;
    }
    html += '<div class="lt-sbox__label">Popular</div><div class="lt-sbox__recent"><a href="/collections/all-watches">Watches</a><a href="/collections/all-clocks">Clocks</a><a href="/collections/tech">Tech</a><a href="/collections/gifts-for-him">Gifts</a></div>';
    body.innerHTML = html;
  };

  let seq = 0;
  let timer = null;
  const update = () => {
    const q = input.value.trim();
    if (!q) {
      idle();
      return;
    }
    const mySeq = ++seq;
    const found = window.LT && window.LT.matches ? window.LT.matches(q).slice(0, 3) : [];
    const teamsHtml = found.length ? `<div class="lt-sbox__label">Teams</div>${found.map(teamRow).join('')}` : '';
    const seeAll = `<a class="lt-sbox__all" href="${esc(searchUrl(q))}">See all results for &ldquo;${esc(q)}&rdquo;</a>`;
    body.innerHTML = `${teamsHtml}<div data-lt-sbox-products></div>${seeAll}`;
    window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      const base = dlg.dataset.predictiveUrl || '/search/suggest';
      fetch(`${base}?q=${encodeURIComponent(q)}&section_id=lt-predictive&resources[type]=product&resources[limit]=10`, { headers: { Accept: 'text/html' } })
        .then((r) => (r.ok ? r.text() : ''))
        .then((html) => {
          if (mySeq !== seq || !html) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const prods = doc.querySelector('[data-lt-predictive-products]');
          const slot = body.querySelector('[data-lt-sbox-products]');
          if (prods && slot && prods.children.length) {
            slot.innerHTML = `<div class="lt-sbox__label">Products</div>`;
            slot.appendChild(prods);
          }
        })
        .catch(() => {});
    }, 180);
  };

  const open = () => {
    if (typeof dlg.showModal === 'function') dlg.showModal();
    else dlg.setAttribute('open', '');
    openBtn.setAttribute('aria-expanded', 'true');
    input.value = '';
    idle();
    window.setTimeout(() => input.focus(), 30);
  };
  const close = () => {
    if (typeof dlg.close === 'function') dlg.close();
    else dlg.removeAttribute('open');
    openBtn.setAttribute('aria-expanded', 'false');
    openBtn.focus();
  };

  openBtn.addEventListener('click', open);
  dlg.addEventListener('click', (e) => {
    if (e.target === dlg) close();
    if (e.target.closest('[data-lt-sbox-close]')) close();
    if (e.target.closest('[data-lt-sbox-clear]')) {
      clearRecents();
      idle();
    }
    const tm = e.target.closest('[data-lt-sbox-team]');
    if (tm && window.LT && window.LT.setMyTeam) window.LT.setMyTeam(tm.getAttribute('data-lt-sbox-team'));
  });
  dlg.addEventListener('close', () => openBtn.setAttribute('aria-expanded', 'false'));
  input.addEventListener('input', update);
  dlg.querySelector('form').addEventListener('submit', (e) => {
    e.preventDefault();
    const q = input.value.trim();
    if (!q) return;
    saveRecent(q);
    window.location.assign(searchUrl(q));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === '/' && !/^(input|textarea|select)$/i.test((document.activeElement || {}).tagName || '') && !dlg.open) {
      e.preventDefault();
      open();
    }
  });
  // team matches need the team list; refresh once it arrives
  document.addEventListener('lt:ready', () => dlg.open && update());
})();
